import { LIVESTREAM_EVENTS } from '@moal/api'
import PropTypes from 'prop-types'
import { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { MODERATORS } from '../../../constants/chatRooms'
import { SocketContext } from '../../../context/socketContext'
import { getRoles } from '../../../utils/APIs/roles'
import { getUserByUserServiceId } from '../../../utils/APIs/users'
import SearchButton from '../../Buttons/SearchButton'
import MessageList from '../../Messages/MessageList'
import UserBio from '../../Utilities/UserBio/UserBio'

const Users = () => {
  const { socket } = useContext(SocketContext)
  const { userId, privateMessageId } = useParams()
  const [loading, setLoading] = useState({
    user: true,
    roles: true
  })
  const [error, setError] = useState(false)
  const [user, setUser] = useState()
  const [roles, setRoles] = useState()
  const [search, setSearch] = useState(null)

  useEffect(() => {
    if (socket) {
      socket.on(LIVESTREAM_EVENTS.PUT_USER, handlePutUser)
    }
    return () => {
      if (socket) {
        socket.off(LIVESTREAM_EVENTS.PUT_USER, handlePutUser)
      }
    }
  }, [socket, user])

  // useEffect to load roles
  useEffect(() => {
    const fetchRoles = async () => {
      setLoading((old) => ({ ...old, roles: true }))
      const response = await getRoles()
      if (response && response.status === 200) {
        setRoles(response.data)
      } else {
        setError(true)
      }
      setLoading((old) => ({ ...old, roles: false }))
    }

    fetchRoles()
  }, [])

  useEffect(() => {
    getUser(userId)
    setSearch(null)
  }, [userId])

  const getUser = async (userId) => {
    setLoading((old) => ({ ...old, user: true }))
    const response = await getUserByUserServiceId(userId, true)
    if (response && response.status === 200 && response.data != null) {
      setUser(response.data)
    } else {
      setError(true)
    }
    setLoading((old) => ({ ...old, user: false }))
  }

  const handlePutUser = async (data) => {
    if (user && data.id === user._id) {
      const response = await getUserByUserServiceId(userId, true)
      if (response && response.status === 200 && response.data != null) {
        setUser((old) => ({ ...old, ...response.data }))
      }
    }
  }

  if (loading.user || loading.roles) {
    return <div>loading</div>
  }

  if (error) {
    return <div>error</div>
  }

  const handleSearch = (e, value) => {
    e.preventDefault()
    setSearch(value)
  }

  return (
    <div className="flex h-full w-full overflow-hidden">
      <div className="flex flex-col w-full gap-2">
        <UserBio user={user} setUser={setUser} />
        <Search handleSearch={handleSearch} />
        <UserChatHistory user={privateMessageId} search={search} />
      </div>
    </div>
  )
}

const UserChatHistory = ({ user, search }) => {
  return (
    <div className="flex flex-col flex-1 gap-2 overflow-y-auto">
      <MessageList channel={MODERATORS} modView userId={user} search={search} />
    </div>
  )
}

UserChatHistory.propTypes = {
  user: PropTypes.string.isRequired,
  search: PropTypes.string
}

const Search = ({ handleSearch }) => {
  const [text, setText] = useState('')

  const handleSubmit = (e) => {
    handleSearch(e, text)
  }

  return (
    <div>
      <form
        onSubmit={(e) => handleSubmit(e)}
        autoComplete="off"
        className="relative flex items-stretch gap-2"
      >
        <div className="flex flex-col w-full">
          <div className="flex flex-row gap-1 border-t dark:border-0 md:border-0 items-end w-full">
            <input
              aria-label="Search messages"
              value={text}
              onChange={(e) => setText(e.target.value)}
              className="grow input"
              placeholder="Search messages..."
            />
            <SearchButton />
          </div>
        </div>
      </form>
    </div>
  )
}

Search.propTypes = {
  handleSearch: PropTypes.func.isRequired
}

export default Users
